





















































































import {
    computed,
    defineComponent,
    inject,
    ref,
    watch,
} from '@vue/composition-api'

// Store
import { StoreKey } from '@/store/Input'
import { StoreKey as FormStoreKey } from '@/store/Form'
import { StoreKey as ErrorStoreKey } from '@/store/Error'

// Component
import RequestCustom from './RequestCustom.vue'
import RequestModel from './RequestModel.vue'
import RequestNew from './RequestNew.vue'

// Util
import { useValidate } from '@/ts/util/validate'

export default defineComponent({
    components: {
        RequestCustom,
        RequestModel,
        RequestNew,
    },
    setup(_, { root }) {
        const formStore = inject(FormStoreKey)
        if (!formStore) {
            throw new Error(`${FormStoreKey} is not provided`)
        }
        const store = inject(StoreKey)
        if (!store) {
            throw new Error(`${StoreKey} is not provided`)
        }
        const errorStore = inject(ErrorStoreKey)
        if (!errorStore) {
            throw new Error(`${ErrorStoreKey} is not provided`)
        }

        const isInputted = ref(false)

        const validateHandler = useValidate({}, (result, flag, inputted) => {
            isInputted.value = inputted as boolean
        })

        const inputFieldClass = computed(() => {
            return {
                'm-invalid': errorStore.request_other.value !== null,
                'm-verify': isInputted.value,
            }
        })

        return {
            request_other_placeholder: computed(() => {
                return (
                    root.$data.request_other_placeholder ??
                    '上記に該当する近い内容がない場合、または具体的なご要望がある場合はこちらにご記入下さい。\n当日アドバイザーが出来る限り準備してご対応いたします。'
                )
            }),
            formStore,
            store,
            errorStore,
            hasCustomRequest: computed(() => {
                return formStore.request_customs.length > 0
            }),
            changeType: () => {
                store.requests = []
            },
            validateHandler,
            inputFieldClass,
        }
    },
})
